import { render, staticRenderFns } from "./Explain.vue?vue&type=template&id=b85a60c8&scoped=true&"
import script from "./Explain.vue?vue&type=script&lang=js&"
export * from "./Explain.vue?vue&type=script&lang=js&"
import style0 from "./Explain.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Explain.vue?vue&type=style&index=1&id=b85a60c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b85a60c8",
  null
  
)

export default component.exports